module.exports = __webpack_public_path__ + "img/18_96.8a10bd01.png";